import React from "react";
import Extrato from "../../components/extrato/Extrato";


export default function () {
  return (
      <Extrato />
  );
}
